module.exports = __webpack_public_path__ + "static/img/preview-off-64px.9041a5c5.png";